import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Lenis from "lenis";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import SiteChrome from "./components/SiteChrome";
import { Toaster } from "sonner";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <SiteChrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/servicii" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </SiteChrome>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#1A1B1A",
            color: "#F4F3EF",
            border: "1px solid #D8D4C8",
          },
        }}
      />
    </div>
  );
}

export default App;
